<block-ui> </block-ui>
    <div class="container-fluid">
      <div class="card card-custom-h">
        <div class="card-body">
          <ul ngbNav #nav="ngbNav" class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder">
            <li ngbNavItem class="nav-item mt-2">
              <a ngbNavLink class="nav-link text-active-primary ms-0 me-10 py-5" (click)="LoadEnqueuedJobs()">{{utilityService.getResourceValue("Enqueued")}}({{JobCountsModel.Enqueued}})</a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div class="card-header border-0 pt-5 px-0  justify-content-end">
                    <div class="card-title" *ngIf="IsEnqueuedFilterLoaded">
                      <form [formGroup]="EnqueuedForm">
                        <BBSF-TextBox [options]="searchTextBox" [group]="EnqueuedForm"></BBSF-TextBox>
                      </form>
                    </div>
                  </div>
                  <div class="card-body py-3 px-0">
                    <!--begin::Permission list-->
                    <div class="table-responsive">
                      <!-- begin::Table -->
                      <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                        <thead>
                          <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                            <th class="min-w-150px">{{utilityService.getResourceValue("Job")}}</th>
                            <th class="min-w-150px">{{utilityService.getResourceValue("State")}}</th>
                          </tr>
                        </thead>
                        <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
                          <tr *ngFor="let job of EnqueuedPagingResult">
                            <td class="text-dark">{{job.job}}</td>
                            <td>{{job.state}}</td>
                          </tr>
                          <tr  *ngIf="EnqueuedPagingResult.length == 0">
                            <td colspan="2">
                              <lib-empty-data></lib-empty-data>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="card-footer border-0">
                    <BBSF-Paging (Items)="setEnqueuedListResult($event)" *ngIf="IsEnqueuedFilterLoaded"
                                 [options]="EnqueuedPaging" [group]="EnqueuedForm" #EnqueuedPagingViewElement>
                    </BBSF-Paging>
                  </div>
                </div>
              </ng-template>
            </li>
            <li ngbNavItem class="nav-item mt-2">
              <a ngbNavLink class="nav-link text-active-primary ms-0 me-10 py-5" (click)="LoadScheduledJobs()">{{utilityService.getResourceValue("Scheduled")}}({{JobCountsModel.Scheduled}})</a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div class="card-body py-3 px-0">
                    <!--begin::Permission list-->
                    <div class="table-responsive">
                      <!-- begin::Table -->
                      <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                        <thead>
                          <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                            <th class="min-w-150px">{{utilityService.getResourceValue("Job")}}</th>
                            <th class="min-w-150px">{{utilityService.getResourceValue("Enqueued")}}</th>
                            <th class="min-w-150px">{{utilityService.getResourceValue("Scheduled")}}</th>
                          </tr>
                        </thead>
                        <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
                          <tr *ngFor="let job of ScheduledPagingResult">
                            <td>{{job.job}}</td>
                            <td>{{job.enqueueAt}}</td>
                            <td>{{job.scheduledAt}}</td>
                          </tr>
                          <tr  *ngIf="ScheduledPagingResult.length == 0">
                            <td colspan="3">
                              <lib-empty-data></lib-empty-data>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="card-footer border-0">
                    <BBSF-Paging (Items)="setScheduledListResult($event)" *ngIf="IsScheduledFilterLoaded"
                                 [options]="ScheduledPaging" [group]="ScheduledForm" #ScheduledPagingViewElement>
                    </BBSF-Paging>
                  </div>
                </div>
              </ng-template>
            </li>
            <li ngbNavItem class="nav-item mt-2">
              <a ngbNavLink class="nav-link text-active-primary ms-0 me-10 py-5" (click)="LoadProcessingJobs()">{{utilityService.getResourceValue("Processing")}}({{JobCountsModel.Processing}})</a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div class="card-body py-3 px-0">
                    <!--begin::Permission list-->
                    <div class="table-responsive">
                      <!-- begin::Table -->
                      <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                        <thead>
                          <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                            <th class="min-w-150px">{{utilityService.getResourceValue("Job")}}</th>
                            <th class="min-w-150px">{{utilityService.getResourceValue("StartedAt")}}</th>
                            <th class="min-w-150px">{{utilityService.getResourceValue("ServerId")}}</th>
                          </tr>
                        </thead>
                        <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
                          <tr *ngFor="let job of ProcessingPagingResult">
                            <td>{{job.job}}</td>
                            <td>{{job.startedAt}}</td>
                            <td>{{job.serverId}}</td>
                          </tr>
                          <tr *ngIf="ProcessingPagingResult.length == 0">
                            <td colspan="3">
                              <lib-empty-data></lib-empty-data>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="card-footer border-0">
                    <BBSF-Paging (Items)="setProcessingListResult($event)" *ngIf="IsProcessingFilterLoaded"
                                 [options]="ProcessingPaging" [group]="ProcessingForm" #ProcessingPagingViewElement>
                    </BBSF-Paging>
                  </div>
                </div>
              </ng-template>
            </li>
            <li ngbNavItem class="nav-item mt-2">
              <a ngbNavLink class="nav-link text-active-primary ms-0 me-10 py-5" (click)="LoadSucceededJobs()">{{utilityService.getResourceValue("Succeeded")}}({{JobCountsModel.Succeeded}})</a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div class="card-body py-3 px-0">
                    <div class="table-responsive">
                      <!-- begin::Table -->
                      <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                        <thead>
                          <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">

                            <th class="min-w-150">{{utilityService.getResourceValue("Job")}}</th>
                            <th class="min-w-150">{{utilityService.getResourceValue("SucceededAt")}}</th>
                            <th class="min-w-150">{{utilityService.getResourceValue("TotalDuration")}}</th>
                          </tr>
                        </thead>
                        <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
                          <tr *ngFor="let job of SucceededPagingResult">
                            <td>{{job.job}}</td>
                            <td>{{job.succeededAt}}</td>
                            <td>{{job.totalDuration}}</td>
                          </tr>
                          <tr *ngIf="SucceededPagingResult.length == 0">
                            <td colspan="3">
                              <lib-empty-data></lib-empty-data>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                  <div class="card-footer border-0">
                    <BBSF-Paging (Items)="setSucceededListResult($event)" *ngIf="IsSucceededFilterLoaded"
                                 [options]="SucceededPaging" [group]="SucceededForm" #SucceededPagingViewElement>
                    </BBSF-Paging>
                  </div>
                </div>
              </ng-template>
            </li>
            <li ngbNavItem class="nav-item mt-2">
              <a ngbNavLink class="nav-link text-active-primary ms-0 me-10 py-5" (click)="LoadFailedJobs()">{{utilityService.getResourceValue("Failed")}}({{JobCountsModel.Failed}})</a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div class="card-body py-3 px-0">
                    <div class="table-responsive">
                      <!-- begin::Table -->
                      <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                        <thead>
                          <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                            <th class="min-w-150">{{utilityService.getResourceValue("FailedAt")}}</th>
                            <th class="min-w-150">{{utilityService.getResourceValue("Job")}}</th>
                            <th class="min-w-150">{{utilityService.getResourceValue("ErrorMessage")}}</th>
                            <th class="min-w-150">{{utilityService.getResourceValue("ErrorMessage")}}</th>
                          </tr>
                        </thead>
                        <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
                          <tr *ngFor="let job of FailedPagingResult">
                            <td>{{job.failedAt}}</td>
                            <td>{{job.job}}</td>
                            <td>{{job.reason}}</td>
                            <td class="failed-job-details directionLtr" *ngIf="job.inFailedState">
                              <div class="expandable">
                                <p> {{job.exceptionType}}</p>
                                <p class="text-muted">
                                  {{job.exceptionMessage}}
                                </p>

                              </div>
                            </td>
                          </tr>
                          <tr *ngIf="FailedPagingResult.length == 0">
                            <td colspan="4">
                              <lib-empty-data></lib-empty-data>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="card-footer border-0">
                    <BBSF-Paging (Items)="setFailedListResult($event)" *ngIf="IsFailedFilterLoaded" [options]="FailedPaging"
                                 [group]="FailedForm" #FailedPagingViewElement>
                    </BBSF-Paging>
                  </div>
                </div>
              </ng-template>
            </li>
            <li ngbNavItem class="nav-item mt-2">
              <a ngbNavLink class="nav-link text-active-primary ms-0 me-10 py-5" (click)="LoadDeletedJobs()">{{utilityService.getResourceValue("Deleted")}}({{JobCountsModel.Deleted}})</a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div class="card-body py-3 px-0">
                    <div class="table-responsive">
                      <!-- begin::Table -->
                      <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                        <thead>
                          <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                            <th class="min-w-150px">{{utilityService.getResourceValue("Job")}}</th>
                            <th class="min-w-150px">{{utilityService.getResourceValue("DeletedAt")}}</th>
                          </tr>
                        </thead>
                        <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
                          <tr *ngFor="let job of DeletedPagingResult">
                            <td>{{job.job}}</td>
                            <td>{{job.deletedAt}}</td>
                          </tr>
                          <tr  *ngIf="DeletedPagingResult.length == 0">
                            <td colspan="2">
                              <lib-empty-data></lib-empty-data>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="card-footer border-0">
                    <BBSF-Paging (Items)="setDeletedListResult($event)" *ngIf="IsDeletedFilterLoaded"
                                 [options]="DeletedPaging" [group]="DeletedForm" #DeletedPagingViewElement>
                    </BBSF-Paging>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav"></div>
        </div>
      </div>

    </div>
 

